export function sortDocuments(documents) {
    let sortedDocuments = {};
    let tmp = {};

    if (documents !== undefined) {
        for (let i = 0; i < documents.length; i++) {
            if (tmp[documents[i].type] === undefined) {
                tmp[documents[i].type] = [];
            }

            if ((tmp[documents[i].type][documents[i].basename+documents[i].canceled+documents[i].type] !== undefined && tmp[documents[i].type][documents[i].basename+documents[i].canceled+documents[i].type].creationDate < documents[i].creationDate) || tmp[documents[i].type][documents[i].basename+documents[i].canceled+documents[i].type] === undefined) {
                tmp[documents[i].type][documents[i].basename+documents[i].canceled+documents[i].type] = ({
                    creationDate: documents[i].creationDate,
                    basename: documents[i].basename,
                    url: documents[i].url,
                    accountancyUrl: documents[i].accountancyUrl,
                    type: documents[i].type,
                    canceled: documents[i].canceled
                });
            }
        }

        for (let key in tmp) {
            if (sortedDocuments[key] === undefined) {
                sortedDocuments[key] = [];
            }

            for (let innerKey in tmp[key]) {
                sortedDocuments[key].push(tmp[key][innerKey]);
            }
        }

        for (let key in sortedDocuments) {
            sortedDocuments[key].sort(function(a, b) {
                let x = a.creationDate;
                let y = b.creationDate;
                if (x > y) {return -1;}
                if (x < y) {return 1;}
                return 0;
            });
            sortedDocuments[key] = sortedDocuments[key].slice(0, 5);
        }
    }

    return sortedDocuments;
}



// WEBPACK FOOTER //
// ./src/utils/document.js